import axios from 'axios';

import authHeader from '../auth-header';
import tokenHeader from '../token-header';

import baseUrl from '../base-url';
const API_URL = baseUrl()+"/api/all/";

const getAppBroadcastUrl = 'broadcast-aplikasi';
const detailAppBroadcastUrl = 'broadcast-aplikasi/';
const postAppBroadcastUrl = 'broadcast-aplikasi';

class AppBroascastService {

    getAppBroadcast(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getAppBroadcastUrl + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            }
        )
    }

    getDetailAppBroadcast(id_broadcast) {
        return axios.get(
            API_URL + detailAppBroadcastUrl + id_broadcast, 
            {
                headers: authHeader()
            }
        )
    }

    postAppBroadcast(request) {
        let form = new FormData();
        form.append('subject', request.subject);
        form.append('pesan', request.pesan);

        if(request.tujuan && request.tujuan.length > 0) {
            for (let i = 0; i < request.tujuan.length; i++) {
                let user = request.tujuan[i];                                
                form.append(`tujuan[${i}].id_user`, user.id_user)
                form.append(`tujuan[${i}].email`, user.email);
            }
        }

        if(request.file && request.file.length > 0) {
            for (let i = 0; i < request.file.length; i++) {
                let singleFile = request.file[i];                
                form.append(`file[${i}]`, singleFile);
            }
        }

        return axios.post(API_URL + postAppBroadcastUrl, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': tokenHeader()
            }
        });
    }

}

export default new AppBroascastService();